<template>
  <div class="floor" :class="{ active: sidebarActive }">
    <Tooltip :visible="tooltip.visible">
      <FlatTooltip :flat="tooltip.data"></FlatTooltip>
    </Tooltip>
    <Windrose class="floor__compass" :rotation="windroseRotation"></Windrose>
    <div class="floor__row">
      <div class="floor__pagination">
        <p class="floor__pagination-title">{{ $t("floor") }}:</p>
        <nav class="floor__nav">
          <router-link
            v-for="floor in lowest * -1"
            :to="
              `/${currentInvestment}/building/${
                $route.params.building
              }/floor/${-1 * floor}`
            "
            :key="-1 * floor"
            class="floor__link"
            v-if="multiBuilding"
            >{{ -1 * floor }}</router-link
          >
          <router-link
            v-if="multiBuilding"
            :to="
              `/${currentInvestment}/building/${$route.params.building}/floor/0`
            "
            class="floor__link"
            >{{ $t("groundFloorShortcut") }}</router-link
          >
          <router-link
            v-else
            to="/floor/0"
            class="floor__link"
            :class="{ disabled: true }"
            >{{ $t("groundFloorShortcut") }}</router-link
          >
          <router-link
            v-for="floor in highest | 'reverse'"
            :to="
              `/${currentInvestment}/building/${$route.params.building}/floor/${floor}`
            "
            :key="floor"
            class="floor__link"
            v-if="multiBuilding"
            >{{ floor }}</router-link
          >
          <router-link
            :to="
              `/${currentInvestment}/building/${$route.params.building}/floor/${floor}`
            "
            :key="floor"
            class="floor__link"
            :class="{ disabled: floor === 1 }"
            v-else
            >{{ floor }}</router-link
          >
        </nav>
      </div>
      <div class="floor__wrapper" :key="$route.params.floor">
        <img
          :src="backgroundUrl"
          alt="floor plan"
          class="floor__image"
          :class="{ loaded: loaded }"
          @load="loaded = true"
        />
        <div class="floor__map" :class="{ loaded: loaded }">
          <component :is="map"></component>
        </div>
        <div class="floor__streets">
          <div class="floor__street--top" v-if="streets.top">
            <span>{{ streets.top }}</span>
          </div>
          <div class="floor__street--bottom" v-if="streets.bottom">
            <span>{{ streets.bottom }}</span>
          </div>
          <div class="floor__street--left" v-if="streets.left">
            <span>{{ streets.left }}</span>
          </div>
          <div class="floor__street--right" v-if="streets.right">
            <span>{{ streets.right }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="floor__legends">
      <div class="floor__legend available">
        <div class="floor__color"></div>
        <div class="floor__text">Dostępne</div>
      </div>
      <div class="floor__legend reserved">
        <div class="floor__color"></div>
        <div class="floor__text">Zarezerwowane</div>
      </div>
      <div class="floor__legend sold">
        <div class="floor__color"></div>
        <div class="floor__text">Sprzedane</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { validateFloor } from "@/plugins/routeValidator.js";
// Components
import Tooltip from "@/components/tooltip.vue";
import FlatTooltip from "@/components/flat/flat-tooltip.vue";
import Windrose from "@/components/windrose.vue";

export default {
  name: "floor",
  data() {
    return {
      loaded: false,
      tooltip: {
        visible: false,
        data: {},
      },
    };
  },
  components: { Tooltip, FlatTooltip, Windrose },
  computed: {
    ...mapState({
      filters: (state) => state.browser.filters,
      flatProperties: (state) => state.browser.flatProperties,
      sidebarActive: (state) => state.browser.sidebarActive,
    }),
    ...mapGetters({
      multiBuilding: "IS_MULTI_BUILDING",
      floor: "GET_INVESTMENT_CURRENT_FLOOR",
      building: "GET_INVESTMENT_CURRENT_BUILDING",
      streets: "GET_CURRENT_STREETS",
      highest: "GET_HIGHEST_FLOOR",
      lowest: "GET_LOWEST_FLOOR",
      currentInvestment: "GET_INVESTMENT_URL",
    }),
    flats() {
      return this.$store.getters.GET_FILTERED_FLATS_BY_FLOOR(this.floor.level);
    },
    map() {
      return this.floor.map || null;
    },
    backgroundUrl() {
      return this.floor.backgroundImage || null;
    },
    windroseRotation() {
      return this.building.floors.windroseRotation;
    },
  },
  watch: {
    flats(value) {
      this.initFlats(value);
    },
  },
  methods: {
    initFlat(flat) {
      let id = flat[this.flatProperties["id"]];
      $(`[data-id="${id}"]`).addClass("active");
      let css = this.$store.getters.GET_STATUS_CLASS(
        flat[this.flatProperties["status"]]
      );
      if (css) {
        $(`[data-id="${id}"]`).addClass(css);
      }
    },
    getFlatById(id) {
      for (let flat of this.flats) {
        if (flat[this.flatProperties["id"]].toUpperCase() == id.toUpperCase()) {
          return flat;
        }
      }
    },
    resetFlats() {
      $("svg .active").removeClass(["active", "sold", "reserved", "available"]);
    },
    initFlats(flats) {
      this.resetFlats();
      for (let flat of flats) {
        this.initFlat(flat);
      }
      $("svg .active").mouseenter((e) => {
        if ($(e.target).hasClass("active")) {
          this.tooltip.visible = true;

          this.tooltip.data = this.getFlatById(e.target.dataset.id);
        }
      });
      $("svg .active").mouseleave((e) => {
        if ($(e.target).hasClass("active")) {
          this.tooltip.visible = false;
        }
      });
      $("svg .active").click((e) => {
        if ($(e.target).hasClass("active") && !$(e.target).hasClass("sold")) {
          this.$router.push({
            path: `/${
              this.currentInvestment
            }/flat/${e.target.dataset.id.toUpperCase()}`,
          });
        }
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    if (validateFloor(to.params)) {
      next();
    } else {
      next("/404");
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (validateFloor(to.params)) {
      next();
    } else {
      next("/404");
    }
  },
  mounted() {
    this.initFlats(this.flats);
  },
};
</script>

<style lang="scss">
$streetWidth: 70%;
$streetThickness: 2rem;
$streetMobileThickness: 1.8rem;
$streetBorder: #bbb;

.floor {
  flex: 1;
  width: 100%;
  min-height: $fullHeight;
  overflow-x: hidden;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  position: relative;

  padding: {
    top: 56px;
    left: $streetThickness / 2;
    right: $streetThickness / 2;
  }
  transition: 250ms;
  // &.active {
  //   padding-right: calc(350px + #{$streetThickness / 2});
  // }
  /* @media screen and (max-width: $xxl) {
    &.active {
      padding-right: calc(350px + #{$streetThickness / 2});
    }
  } */

  // @media screen and (max-width: $md) {
  //   &.active {
  //     padding-right: $streetThickness / 2;
  //   }
  // }
}

.floor__wrapper {
  position: relative;
  max-width: $lg;
  max-height: 100vh;
  margin: {
    left: auto;
    right: auto;
  }
  padding: $streetThickness;

  @media screen and (max-width: $lg) {
    max-width: 100%;
  }

  @media screen and (max-width: $sm) {
    padding: $streetMobileThickness;
  }
}

.floor__compass {
  position: absolute;
  top: -8px;
  left: 0;
}

.floor__table {
  margin-top: 50px;
}

.floor__tooltip--container {
  max-width: $lg;
  width: 100%;
  position: relative;
  margin-top: 20px;
}

.floor__image {
  width: 950px;
  max-height: 100%;

  transition: 850ms;
  transform-origin: center;
  transform: scale(0);
  &.loaded {
    transform: scale(1);
  }

  @media screen and (max-width: $lg) {
    width: 800px;
  }

  @media screen and (max-width: $mlg) {
    width: 700px;
  }

  @media screen and (max-width: $md) {
    width: 600px;
  }

  @media screen and (max-width: $sm) {
    width: 90vw;
  }

  // @media screen and (min-width: $md) and (max-height: 800px) {
  //   width: 50vw;
  // }
}

.floor__map {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: 850ms;
  transform-origin: center;
  transform: scale(0);
  padding: $streetThickness;
  @media screen and (max-width: $sm) {
    padding: $streetMobileThickness;
  }
  &.loaded {
    transform: scale(1);
  }
  polygon,
  rect {
    /* visibility: hidden;
    opacity: 0; */

    fill: $primaryColor;
    fill-opacity: 0.6;
    cursor: pointer;

    transition: 250ms;
    &:hover {
      fill-opacity: 0.85;
    }
  }

  .active {
    visibility: visible;
    opacity: 1;
    fill-opacity: 0.4;
  }
  .sold {
    fill: $sold;
    cursor: initial;
  }
  .available {
    fill: $available;
  }
  .reserved {
    fill: $reserved;
  }
}

.floor__legends {
  width: 100%;
  flex-basis: 100%;
  max-width: $lg;

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: {
    top: 2%;
  }
  @media screen and (max-width: $lg) {
    max-width: calc(100% - #{$streetThickness * 2});
  }
  @media screen and (max-width: $sm) {
    flex-direction: column;
    margin: {
      top: 4%;
    }
    align-items: flex-start;
    max-width: calc(100% - #{$streetMobileThickness * 2});
  }
}

.floor__legend {
  display: flex;
  margin : {
    right: 16px;
    top: 5px;
  }
  &.sold {
    .floor__color {
      background: $sold;
    }
  }
  &.available {
    .floor__color {
      background: $available;
    }
  }
  &.reserved {
    .floor__color {
      background: $reserved;
    }
  }
}

.floor__color {
  width: 20px;
  height: 20px;
  margin-right: 8px;
  //border: 1px solid lighten(#000, 50%);
  box-shadow: 0 1px 4px rgba(#000, 0.2);
}

.floor__text {
  color: #000;
  font-weight: 400;
  font-size: 16px;
}

.floor__street {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
  color: #191919;
  background: $lighterGray;
  border-radius: 8px;
  font-size: 14px;
}

.floor__street--top {
  @extend .floor__street;
  width: $streetWidth;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: $streetThickness;
  @media screen and (max-width: $sm) {
    height: $streetMobileThickness;
  }
}

.floor__street--bottom {
  @extend .floor__street;
  width: $streetWidth;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  height: $streetThickness;
  @media screen and (max-width: $sm) {
    height: $streetMobileThickness;
  }
}

.floor__street--left {
  @extend .floor__street;
  height: $streetWidth;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  width: $streetThickness;
  @media screen and (max-width: $sm) {
    width: $streetMobileThickness;
  }
}

.floor__street--left span {
  transform: rotate(-90deg);
  white-space: nowrap;
}

.floor__street--right {
  @extend .floor__street;
  height: $streetWidth;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: $streetThickness;
  @media screen and (max-width: $sm) {
    width: $streetMobileThickness;
  }
}

.floor__street--right span {
  transform: rotate(90deg);
  white-space: nowrap;
}

.floor__pagination-title {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;
}

.floor__pagination {
  position: relative;
  max-width: $lg;

  overflow: auto;
  margin: {
    top: 10px;
    bottom: 10px;
  }

  @media screen and (max-width: $lg) {
    max-width: calc(100% - #{$streetThickness * 2});
  }
  @media screen and (min-width: $md+1px) {
    margin-right: $streetThickness / 2;
    overflow-x: visible;
    padding-top: 20px;
    width: 110px;
    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar {
      width: 8px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: $primaryColor;
    }
  }
  @media screen and (max-width: $sm) {
    max-width: calc(100% - #{$streetMobileThickness * 2});
  }
  @media screen and (max-height: 1000px) and (min-width: $md) {
    align-self: flex-start;
    max-height: calc(#{$fullHeight} - 15vw);
    margin: {
      top: 30px;
      bottom: 0px;
    }
  }
  @media screen and (min-height: 1000px) {
    height: calc(#{$fullHeight} - 5vh - 70px);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

.floor__nav {
  display: flex;
  @media screen and (min-width: $md+1px) {
    flex-direction: column-reverse;
    align-items: center;
    padding-left: 12px;
  }
}

.floor__link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 8px;
  border: 1px solid #ddd;
  box-shadow: 0 0 8px 1px rgba(0, 0, 0, 0.1);
  margin: {
    right: 14px;
    top: 10px;
    bottom: 10px;
  }

  font-weight: 500;
  font-size: 14px;
  color: #000;
  text-decoration: none;
  background: #eee;
  &.active {
    background: $primaryColor;
  }
}

.floor__row {
  display: flex;
  flex: 1;
  max-width: $lg;
  width: 100%;
  align-items: center;
  @media screen and (max-width: $lg) {
    max-width: 100%;
  }
  @media screen and (max-width: $md) {
    flex-direction: column-reverse;
    justify-content: flex-end;
    padding-top: 2rem;
  }
}

.disabled {
  opacity: 0.4;
  pointer-events: none;
}
</style>
